import { Slide } from "packages/lesson/dist/@types";

import { task as task06 } from "../../../../../task/course-05/lesson-17/task-06";

const task: Slide = {
  titleHtml:
    "If we measure the reverberation time, levels in the source and receiving room the</br>correct statement for the results obtained by repeating measurements  is:",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task06.id,
        },
      },
    },
  },
};

export default task;
